import { useMutation, useQueryClient } from "@tanstack/react-query";
import postsAPI from "../../api/posts/api";

export function useDeletePost() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postsAPI.deletePost,
    onSuccess: (data, variables) => {
      // Invalidate and refetch posts list
      queryClient.invalidateQueries({ queryKey: ["posts"] });

      // Remove specific post from cache
      queryClient.removeQueries({ queryKey: ["posts", variables] });
    },
    onError: (error) => {
      console.error("Delete post failed:", error);
    },
  });
}
